/*
 * js-error-tracker
 * ----------------
 * Captures window `error` + `unhandledrejection` events and forwards them to
 * Microsoft Clarity as a filterable `js_error` custom event with diagnostic tags.
 *
 * Purpose (root-cause tooling, not a fix):
 *   - Separate OUR theme errors (jserr_origin=self) from opaque cross-origin
 *     "Script error." noise (jserr_opaque=1).
 *   - Capture stack + environment probes so errors like `removeTrapFocus is not
 *     defined` and the webkit-bridge error can be root-caused from real sessions.
 *
 * Loaded via snippets/js-error-tracker.liquid from both theme + quiz layouts
 * (shared source of truth). External file so it can never render as page text.
 * Safe: additive instrumentation only, no behaviour change, no error suppression.
 * Buffers errors until clarity() exists, so it works regardless of where each
 * layout loads the Clarity queue stub (theme = head, quiz = end of body).
 */
(function (w) {
  var buf = [], sent = 0, seen = {}, CAP = 10;

  function cut(s, n) { return String(s == null ? '' : s).slice(0, n); }

  // self = our storefront origin or the Shopify theme-asset CDN; 3p = anything else.
  function classify(src) {
    if (!src) return '';
    try {
      var h = new URL(src, w.location.href).host;
      if (h === w.location.host) return 'self';
      if (/(^|\.)cdn\.shopify\.com$/.test(h)) return 'self';
      return '3p';
    } catch (e) { return ''; }
  }

  function flush() {
    if (typeof w.clarity !== 'function') return;
    while (buf.length) {
      var r = buf.shift();
      w.clarity('set', 'jserr_msg', r.msg);
      w.clarity('set', 'jserr_src', r.src);
      w.clarity('set', 'jserr_origin', r.origin);
      w.clarity('set', 'jserr_opaque', r.opaque);
      w.clarity('set', 'jserr_line', r.line);
      w.clarity('set', 'jserr_stack', r.stack);
      w.clarity('set', 'jserr_page', r.page);
      w.clarity('set', 'env_global_js', r.envGlobal);
      w.clarity('set', 'env_webkit', r.envWebkit);
      w.clarity('event', 'js_error');
    }
  }

  function report(msg, src, line, err) {
    if (sent >= CAP) return;
    var key = cut(msg, 80) + '|' + cut(src, 80) + '|' + line;
    if (seen[key]) return;
    seen[key] = 1; sent++;

    // Textbook cross-origin-opaque signature: browser stripped everything.
    var opaque = (msg === 'Script error.' || msg === 'Script error') && !src && !line && !err;
    var stack = err && err.stack ? err.stack.split('\n').slice(0, 3).join(' | ') : '';

    buf.push({
      msg: cut(msg, 200),
      src: cut(src, 200),
      line: line ? String(line) : '',
      origin: classify(src) || (opaque ? '3p' : ''),
      opaque: opaque ? '1' : '0',
      stack: cut(stack, 300),
      page: cut(w.location.pathname, 120),
      // Probes the `removeTrapFocus is not defined` theory: was global.js present?
      envGlobal: (typeof w.removeTrapFocus === 'function') ? '1' : '0',
      // Probes the webkit-bridge error: our stub present, or external object?
      envWebkit: (typeof w.webkit) + (w.__arteWebkitStub ? '/stub' : '')
    });
    flush();
  }

  w.addEventListener('error', function (e) {
    report(e.message, e.filename, e.lineno, e.error);
  });
  w.addEventListener('unhandledrejection', function (e) {
    var reason = e && e.reason;
    if (reason && typeof reason === 'object') {
      report(reason.message || 'unhandledrejection', reason.fileName || '', reason.lineNumber || 0, reason);
    } else {
      report('unhandledrejection: ' + cut(reason, 120), '', 0, null);
    }
  });

  // Safety net: flush errors buffered before clarity() existed (e.g. head-time
  // errors on the quiz layout, which loads the Clarity stub near the end of body).
  var tries = 0, iv = w.setInterval(function () {
    if (typeof w.clarity === 'function') { flush(); w.clearInterval(iv); }
    else if (++tries >= 20) { w.clearInterval(iv); }
  }, 500);
})(window);
